module.exports = __webpack_public_path__ + "img/hanna_r.7c24c359.jpg";